import axios from '../../http'

class DBAddress {
  // 城市列表
  getDBAddressMock() {
    const url = '/address.json'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBAddress;
